import { render, staticRenderFns } from "./CutOffInfo.vue?vue&type=template&id=1a3f2cf4&scoped=true"
import script from "./CutOffInfo.vue?vue&type=script&lang=js"
export * from "./CutOffInfo.vue?vue&type=script&lang=js"
import style0 from "./CutOffInfo.vue?vue&type=style&index=0&id=1a3f2cf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3f2cf4",
  null
  
)

export default component.exports